import React, { useState, useEffect, useRef } from "react";
import "./Template_2.css";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import DefaultData from "../../CompanyData/DefaultData";

const Template_2_TravelTypes = () => {
  const [travelTypes, setTravelTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const scrollContainerRef = useRef(null);

  const companyId = DefaultData.DEFAULTCOMPANYID;

  // Static mapping (icons + descriptions)
  const travelTypeMeta = {
    Honeymoon: {
      icon: "fa-solid fa-heart",
      description: "Romantic escapes for newlyweds",
      color: "#FF6B6B",
    },
    Family: {
      icon: "fa-solid fa-users",
      description: "Fun-filled adventures for the whole family",
      color: "#4ECDC4",
    },
    Pilgrims: {
      icon: "fa-solid fa-hands-praying",
      description: "Spiritual journeys to sacred places",
      color: "#FFD166",
    },
    Corporate: {
      icon: "fa-solid fa-briefcase",
      description: "Business travel and corporate packages",
      color: "#6A0572",
    },
    Group: {
      icon: "fa-solid fa-user-group",
      description: "Great deals for group adventures",
      color: "#118AB2",
    },
  };

  // Helper: capitalize first letter, lowercase rest
  const formatTitle = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

  useEffect(() => {
    const GetTravelTypes = async () => {
      setIsLoading(true);
      try {
        const travelTypesResponse = await apiService.getAll(
          `${config.GETALLTRAVELTYPES}?companyId=${companyId}`
        );

        const mergedData = (travelTypesResponse || []).map((item) => {
          const formattedName = formatTitle(item.travelTypeName);
          const meta = travelTypeMeta[formattedName] || {};

          return {
            id: item.travelTypeId,
            title: formattedName,
            icon: meta.icon || "fa-solid fa-plane",
            description: meta.description || "Explore amazing journeys",
            color: meta.color || "#3a86ff",
          };
        });

        setTravelTypes(mergedData);
      } catch (error) {
        console.error("Failed to fetch travel types:", error);
      } finally {
        setIsLoading(false);
      }
    };

    GetTravelTypes();
  }, [companyId]);

  // Auto-scroll functionality
  useEffect(() => {
    if (travelTypes.length === 0) return;

    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let scrollAmount = 0;
    const scrollSpeed = 1;

    const autoScroll = () => {
      if (scrollContainer) {
        scrollAmount += scrollSpeed;

        if (scrollAmount >= scrollContainer.scrollWidth / 2) {
          scrollAmount = 0;
          scrollContainer.scrollLeft = 0;
        } else {
          scrollContainer.scrollLeft = scrollAmount;
        }
      }
    };

    const scrollInterval = setInterval(autoScroll, 50);

    return () => {
      clearInterval(scrollInterval);
    };
  }, [travelTypes]);

  return (
    <section className="Template_2-travel-types">
      <div className="Template_2 container">
        <div className="Template_2 section-title">
          <h2>Travel Styles</h2>
          <p>
            Find the perfect travel experience that matches your preferences
          </p>
        </div>

        {isLoading ? (
          <div className="Template_2-loading-container">
            <div className="Template_2-loading-spinner"></div>
            <p>Loading travel types...</p>
          </div>
        ) : (
          <div
            className="Template_2-travel-types-scroll-container"
            ref={scrollContainerRef}
          >
            <div className="Template_2-travel-types-scroll-content">
              {travelTypes.map((type) => (
                <div
                  key={type.id}
                  className="Template_2-travel-type-item"
                  style={{ "--accent-color": type.color }}
                >
                  <div className="Template_2-travel-type-content">
                    <div className="Template_2-icon-container">
                      <i className={type.icon}></i>
                    </div>
                    <div className="Template_2-text-content">
                      <h3>{type.title}</h3>
                      <p>{type.description}</p>
                    </div>
                    <div className="Template_2-hover-indicator">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              ))}
              {/* Duplicate for seamless looping */}
              {travelTypes.map((type) => (
                <div
                  key={`duplicate-${type.id}`}
                  className="Template_2-travel-type-item"
                  style={{ "--accent-color": type.color }}
                >
                  <div className="Template_2-travel-type-content">
                    <div className="Template_2-icon-container">
                      <i className={type.icon}></i>
                    </div>
                    <div className="Template_2-text-content">
                      <h3>{type.title}</h3>
                      <p>{type.description}</p>
                    </div>
                    <div className="Template_2-hover-indicator">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Template_2_TravelTypes;
